import mixitup from 'mixitup';
const mixitupContainer = document.querySelector('.mix-container');
if (mixitupContainer) {
  var mixer = mixitup(mixitupContainer);
}

